module.exports = __webpack_public_path__ + "img/text_apply.86d629ad.png";